import { mdiClose } from '@mdi/js';
import Icon from '@mdi/react';
import { bannerCookiePolicyMessages, COOKIE_POLICY_URL, FILENAME_COOKIE, updateHideBannerCookiePolicy } from 'azshared';
import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import { useDispatch } from 'react-redux';
import { useAppSelector } from '../../hooks/redux';
import './banner-cookie-policy.scss';

export const BannerCookiePolicy = () => {
  const { formatMessage } = useIntl();
  const dispatch = useDispatch();

  const { hideBannerCookiePolicy } = useAppSelector((state) => state.data.user);

  const handleClose = useCallback(() => {
    dispatch(updateHideBannerCookiePolicy(true));
  }, [dispatch]);

  const handleKeyDown = useCallback(
    (event: React.KeyboardEvent) => {
      if (event.key === 'Enter' || event.key === ' ') {
        event.preventDefault();
        handleClose();
      }
    },
    [handleClose]
  );

  if (hideBannerCookiePolicy) {
    return null;
  }

  return (
    <div className='banner-cookie-policy'>
      <div className='text-banner'>
        {formatMessage(bannerCookiePolicyMessages.bannerMessage)}
        <a className='banner-link' href={COOKIE_POLICY_URL} download={FILENAME_COOKIE}>
          {formatMessage(bannerCookiePolicyMessages.bannerLink)}
        </a>
      </div>
      <span className='icon' onKeyDown={handleKeyDown} onClick={handleClose} tabIndex={0}>
        <Icon size={0.8} path={mdiClose} />
      </span>
    </div>
  );
};
